import {type UIGameManager} from './UIGameManager.ts'
import {GameStateEnums} from '../../../../shared/GameEnums.ts'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {type PauseState} from '@colonist/game-state-types'
import {KeyBindController, ShortcutLocation} from '../KeyBindController.ts'

export class UIGamePauseController {
    private readonly uiGameManager: UIGameManager

    private readonly state: PauseState = {
        paused: false,
    }

    constructor(uiGameManager: UIGameManager) {
        this.uiGameManager = uiGameManager

        this.createKeyBind()
    }

    private createKeyBind() {
        KeyBindController.bindKey('KeyP', () => this.onAutoPauseTriggered(), () => this.keyBindListener(), ShortcutLocation.InGame)
    }

    private keyBindListener() {
        if(this.state.paused) return false
        return true
    }

    togglePause(state: PauseState) {
        this.state.remainingPauseTime = state.remainingPauseTime
        this.state.paused = state.paused

        this.uiGameManager.eventController.sendEvent(this.state.paused, UIGameEventEnums.GamePauseToggled)
    }

    isPaused(): boolean {
        return this.state.paused
    }

    onAutoPauseTriggered() {
        if(this.state.paused) return
        this.uiGameManager.socketGameSend.submitChat('/pause')
    }

    pauseIfSinglePlayer() {
        if(this.uiGameManager.gameController.isReplay) return
        if(this.state.paused) return
        if(!this.uiGameManager.gameState.hasOnlyOneHumanPlayer()) return
        this.uiGameManager.socketGameSend.togglePause()
    }
}
